import $ from 'jquery'
import Swiper from 'swiper/dist/js/swiper'
import tippy from 'tippy.js'

function draggableFloors() {

  const dragMenu = document.getElementsByClassName('c-spaces__menu')
  const slides = document.getElementsByClassName('c-spaces__slides')

  if ($(window).width() > 767) {
    var swiperDirection = 'vertical'
    var touchEnabled = 0
  } else {
    var swiperDirection = 'horizontal'
    var touchEnabled = 1
  }

  const floorsMenu = new Swiper(dragMenu, {
    direction: swiperDirection,
    slidesPerView: 4,
    spaceBetween: 0,
    mousewheel: true,
    centeredSlides: true,
    freeMode: false,
    freeModeMomentum: false,
    loop: true,
    slideToClickedSlide: true,
    slideActiveClass: 'active-floor',
    touchRatio: touchEnabled,
  })

  const floorsSlides = new Swiper(slides, {
    direction: 'horizontal',
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    touchRatio: touchEnabled,
  })

  const menuSwiper = document.querySelector('.c-spaces__menu').swiper
  const floorsSwiper = document.querySelector('.c-spaces__slides').swiper

  menuSwiper.on('slideChange', () => {
    const activeFloor = menuSwiper.slides[menuSwiper.activeIndex]
    floorsSwiper.slideToLoop(menuSwiper.realIndex)

  })

  floorsSwiper.on('slideChange', () => {
    const activeFloor = floorsSwiper.slides[floorsSwiper.activeIndex]
    menuSwiper.slideToLoop(floorsSwiper.realIndex)

  })

  $('.c-spaces__image-container polygon, .c-spaces__image-container rect, .c-spaces__image-container polyline').each(function (index) {
    const space_id = $(this).attr('id')
    if ($(`#space-${space_id}`).length > 0) {
      tippy(`polygon[id="${space_id}"]`, {
        allowHTML: true,
        content: document.querySelector(`#space-${space_id}`),
        arrow: true,
        animation: 'shift-toward',
        interactive: 'true',
        theme: 'dark',
        hideOnClick: 'false',
      })
    }
    if ($(`#space-${space_id}`).length > 0) {
      tippy(`rect[id="${space_id}"]`, {
        allowHTML: true,
        content: document.querySelector(`#space-${space_id}`),
        arrow: true,
        animation: 'shift-toward',
        interactive: 'true',
        theme: 'dark',
        hideOnClick: 'false',
      })
    }
    if ($(`#space-${space_id}`).length > 0) {
      tippy(`polyline[id="${space_id}"]`, {
        allowHTML: true,
        content: document.querySelector(`#space-${space_id}`),
        arrow: true,
        animation: 'shift-toward',
        interactive: 'true',
        theme: 'dark',
        hideOnClick: 'false',
      })
    }

  })

}

export default draggableFloors
